import apiClient from './api';
import {
  Comment,
  CreateCommentRequest,
  UpdateCommentRequest,
} from '../types';

export const commentService = {
  // 내 댓글 목록 조회
  async getMyComments(): Promise<Comment[]> {
    const response = await apiClient.get<Comment[]>('/comments');
    return response.data;
  },

  // 내 댓글만 조회
  async getMyCommentsOnly(): Promise<Comment[]> {
    const response = await apiClient.get<Comment[]>('/comments/my');
    return response.data;
  },

  // 특정 사용자의 댓글 조회 (ADMIN만)
  async getUserComments(userId: string): Promise<Comment[]> {
    const response = await apiClient.get<Comment[]>(`/comments/user/${userId}`);
    return response.data;
  },

  // 공지사항별 댓글 조회
  async getAnnouncementComments(announcementId: string): Promise<Comment[]> {
    const response = await apiClient.get<Comment[]>(`/comments/announcement/${announcementId}`);
    return response.data;
  },

  // 공지사항별 댓글 수 조회
  async getAnnouncementCommentCount(announcementId: string): Promise<number> {
    const response = await apiClient.get<number>(`/comments/announcement/${announcementId}/count`);
    return response.data;
  },

  // 입법예고별 댓글 조회
  async getLegislativeNoticeComments(legislativeNoticeId: string): Promise<Comment[]> {
    const response = await apiClient.get<Comment[]>(`/comments/legislative-notice/${legislativeNoticeId}`);
    return response.data;
  },

  // 입법예고별 댓글 수 조회
  async getLegislativeNoticeCommentCount(legislativeNoticeId: string): Promise<number> {
    const response = await apiClient.get<number>(`/comments/legislative-notice/${legislativeNoticeId}/count`);
    return response.data;
  },

  // 특정 댓글 조회
  async getComment(commentId: string): Promise<Comment> {
    const response = await apiClient.get<Comment>(`/comments/${commentId}`);
    return response.data;
  },

  // 댓글 작성
  async createComment(commentData: CreateCommentRequest): Promise<Comment> {
    const response = await apiClient.post<Comment>('/comments', commentData);
    return response.data;
  },

  // 댓글 수정
  async updateComment(commentId: string, commentData: UpdateCommentRequest): Promise<Comment> {
    const response = await apiClient.patch<Comment>(`/comments/${commentId}`, commentData);
    return response.data;
  },

  // 댓글 삭제
  async deleteComment(commentId: string): Promise<void> {
    await apiClient.delete(`/comments/${commentId}`);
  },
}; 